/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpRightIcon24Solid = forwardRef('ArrowDCornerUpRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.56 1.69a1.5 1.5 0 0 0-2.12 2.12L17.628 8H7.5A4.5 4.5 0 0 0 3 12.5v9a1.5 1.5 0 0 0 3 0v-9A1.5 1.5 0 0 1 7.5 11h10.129l-4.19 4.19a1.5 1.5 0 0 0 2.122 2.12l5.503-5.503a3.262 3.262 0 0 0 0-4.614l-5.503-5.504Z" })));
});
